import React, {FC, useState} from "react";
import {Button} from "../../../../index";
import {Alert, Select, Spin} from "antd";
import {useViewerStore} from "../../../../../store/store";

interface ProductionValidationAlertProps {
    errors: string[];
}
const ProductionValuesValidation: FC<ProductionValidationAlertProps> = ({errors}) => {


    const sceneViewer = useViewerStore((state) => state.sceneViewer);


    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false});
    };


    return (
        <>

            <p>Finalization blocked: Please refresh shade or verify the design.</p>
            <br/>
            <details>
                <summary>Error Details: (Click to Expand)</summary>
                <br/>
                {
                    errors.map((error: string, index: number) => (
                        <div key={index}>
                            <p>{error}</p>
                        </div>
                    ))
                }
                <br/>
            </details>
            <br/>
            <Alert
                style={{color: "black"}}
                message="Note: Invalid values refers to values which are 0, NaN, undefined, null or out of valid range."
                type="info"
                showIcon
            />
            <br/>
            <div className="modal-bottom-action-button-container">
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="modal-cancel-button"
                    onClick={cancelFinalize}
                >
                    Close
                </Button>
            </div>
        </>

    );
};

export default ProductionValuesValidation;
